// Which origin the SPA calls for the API.
//
// Split out of api.js so the rule can be tested without a DOM: api.js reads
// window.location and pulls in the paywall modal, neither of which exists in
// node --test. The rule itself is pure, and it is the kind of rule that is
// wrong silently — a page that cannot reach its own API just says "Failed to
// fetch" and looks like a network problem.
//
// Local dev has TWO shapes, and the old rule only knew one of them:
//
//   1. a static server holds the SPA and the API is a separate process on :3000
//      — `serve:live` on :8080 (the source tree) and `web (dist)` on :8082;
//   2. the API serves its own SPA out of dist/ on one origin — `serve:api`, and
//      any worktree that scripts/control-app.mjs brings up on a derived port.
//
// Hardcoding :3000 for every localhost page covers (1) and breaks (2) the moment
// the port is not 3000, which is exactly what a second worktree is for. So ask
// which shape this is: a known static dev port means the API is elsewhere;
// anything else on localhost is the API serving this very page.

/** The dev servers that serve the SPA but not the API (see .claude/launch.json). */
export const STATIC_DEV_PORTS = new Set(["8080", "8082"]);

const SENDINVO_API = "https://api.sendinvo.com";
const RENDER_API = "https://ar-ap-api-frankfurt.onrender.com";

/**
 * @param {{hostname: string, port: string, protocol: string, origin: string}} location
 * @returns {string} Origin of the API, no trailing slash.
 */
export function resolveApiBase({ hostname, port, protocol, origin }) {
  if (hostname === "localhost" || hostname === "127.0.0.1") {
    return STATIC_DEV_PORTS.has(String(port)) ? `${protocol}//${hostname}:3000` : origin;
  }
  if (hostname === "sendinvo.com" || hostname.endsWith(".sendinvo.com")) return SENDINVO_API;
  return RENDER_API;
}
